//服务商登录菜单信息
export const servehomemenu = [
  {
    index: "0",
    total_name: "商品",
    icon_class: "el-icon-s-goods",
    children: [
      {
        index: "/onlinebaseclassinfo",
        icon_class: "el-icon-menu",
        name: "线上类别信息"
      },
      {
        index: "/goodsInfo",
        icon_class: "el-icon-s-goods",
        name: "商品基本信息"
      },
      {
        index: "/mchSalesList",
        icon_class: "el-icon-s-data",
        name: "热销商品排行"
      },
      {
        index: "/auditGoods",
        icon_class: "el-icon-s-claim",
        name: "新品审核"
      }

    ]
  },
  {
    index: "1",
    total_name: "设置",
    icon_class: "el-icon-s-tools",
    children: [
      {
        index: "/sinformation",
        icon_class: "el-icon-edit-outline",
        name: "服务商信息"
      },
      /* {
        index: "/tigerzzvideo",
        icon_class: "el-icon-s-finance",
        name: "泰格学习视频"
      }, */

      /* {
      index: "/advertised",
      icon_class: "el-icon-orange",
      name: "小程序广告"
    },*/
      /* {
        index: "/log",
        icon_class: "el-icon-chat-line-square",
        name: "系统日志"
      }, */
      /* {
        index: "/changeBank",
        icon_class: "el-icon-s-management",
        name: "修改结算账户"
      }, */
      {
        index: "/sonService",
        icon_class: "el-icon-s-custom",
        name: "子服务商"
      }
    ]
  },
  {
    index: "2",
    total_name: "会员",
    icon_class: "el-icon-vip",
    children: [
      {
        index: "/vip",
        icon_class: "el-icon-vip-son",
        name: "会员卡信息修改"
      },
      /* {
        index: "/MyCard",
        icon_class: "el-icon-bank-card",
        name: "会员卡创建"
      }, */
      {
        index: "/cardCantent",
        icon_class: "el-icon-connection",
        name: "开卡填写内容"
      } /* ,
      {
        index: "/getCode",
        icon_class: "el-icon-magic-stick",
        name: "领卡二维码"
      } */
    ]
  },
  {
    index: "3",
    total_name: "权限",
    icon_class: "el-icon-s-custom",
    children: [
      {
        index: "/userGroup",
        icon_class: "el-icon-user-solid",
        name: "角色管理"
      },
      {
        index: "/Permission",
        icon_class: "el-icon-finished",
        name: "用户授权"
      },
      {
        index: "/mchPermission",
        icon_class: "el-icon-edit",
        name: "店铺权限管理"
      }
    ]
  },
  {
    index: "4",
    total_name: "门店",
    icon_class: "el-icon-s-shop",
    children: [
      {
        index: "/createMerchant",
        icon_class: "el-icon-upload",
        name: "商户管理"
      },
      {
        index: "/underinfo",
        icon_class: "el-icon-view",
        name: "门店服务管理"
      },
      // {
      //   index: "/shopmanage",
      //   icon_class: "el-icon-s-grid",
      //   name: "所有店铺"
      // },
      {
        index: "/feed",
        icon_class: "el-icon-s-claim",
        name: "商户支付进件"
      }, {
        index: "/mchApplyHistery",
        icon_class: "el-icon-s-order",
        name: "支付进件记录"
      }
    ]
  },
  {
    index: "5",
    total_name: "支付",
    icon_class: "el-icon-s-finance",
    children: [
      {
        index: "/swiftConfigure",
        icon_class: "el-icon-upload",
        name: "威富通商户信息"
      },
      {
        index: "/serviceSwift",
        icon_class: "el-icon-upload",
        name: "威富通商户入驻"
      }
    ]
  }
];

//个人登录菜单信息
export const phomemenu = [
  {
    index: "1",
    total_name: "基本信息",
    icon_class: "iconfont icon-style-item icon-wodeshangpin",
    children: [
      {
        index: "/classInfo",
        icon_class: "el-icon-menu",
        name: "商品类别"
      },
      {
        index: "/goodsInfo",
        icon_class: "el-icon-s-goods",
        name: "商品信息"
      }
    ]
  },
  {
    index: "2",
    icon_class: "el-icon-s-home",
    total_name: "仓库管理",
    children: [
      {
        index: "/reportware",
        icon_class: "el-icon-plus",
        name: "生成单据"
      }
    ]
  },
  {
    index: "3",
    icon_class: "el-icon-s-check",
    total_name: "电子合约",
    children: [
      {
        index: "/createContract",
        icon_class: "el-icon-edit",
        name: "电子合约"
      },
      {
        index: "/collection",
        icon_class: "el-icon-tickets",
        name: "收费项管理"
      }
    ]
  }
  /*  {
    index: 4,
    icon_class: "el-icon-s-order",
    total_name: "财务管理",
    children: [
      {
        index: "/business",
        icon_class: "el-icon-money",
        name: "账单管理"
      }
    ]
  } */
];

//
//店铺登录菜单信息
export const shophomemenu = [
  {
    index: "7",
    total_name: "商城",
    icon_class: "el-icon-s-shop",
    children: [
      {
        index: "/classGenerate",
        icon_class: "el-icon-menu",
        name: "商品信息",
        children: [
          {
            index: "/classGenerate",
            icon_class: "el-icon-menu",
            name: "分类信息"
          },
          {
            index: "/goodsList",
            icon_class: "el-icon-s-goods",
            name: "我的商品"
          },
          {
            index: "/LogisticsList",
            icon_class: "el-icon-s-goods",
            name: "物流模板"
          }
        ]
      }, /* {
        index: "/order",
        icon_class: "el-icon-menu",
        name: "订单信息",
        children: [
          {
            index: "/order",
            icon_class: "el-icon-menu",
            name: "订单信息"
          }
        ]
      }, */ {
        index: "/webView",
        icon_class: "el-icon-menu",
        name: "物流配送",
        children: [
          {
            index: "/webView",
            icon_class: "el-icon-menu",
            name: "物流"
          }
        ]
      }, {
        index: "/renovation",
        icon_class: "el-icon-menu",
        name: "店铺装修",
        children: [
          {
            index: "/renovation",
            icon_class: "el-icon-menu",
            name: "店铺装修"
          }
        ]
      }, {
        index: "/customerService",
        icon_class: "el-icon-menu",
        name: "客服管理",
        children: [
          {
            index: "/customerService",
            icon_class: "el-icon-menu",
            name: "客服信息"
          }, {
            index: "/chatMessage",
            icon_class: "el-icon-menu",
            name: "客服"
          }
        ]
      }, {
        index: "/vip",
        icon_class: "el-icon-menu",
        name: "卡卷管理",
        children: [
          {
            index: "/CreateCoupons",
            icon_class: "el-icon-s-ticket",
            name: "快速制卷"
          },
          {
            index: "/couponList",
            icon_class: "el-icon-s-ticket",
            name: "卷列表"
          }
        ]
      }

    ]
  },
  /* {
    index: "0",
    total_name: "基本信息",
    icon_class: "iconfont icon-style-item icon-wodeshangpin",
    children: [
      {
        index: "/classInfo",
        icon_class: "el-icon-menu",
        name: "类别信息"
      },
      {
        index: "/supplier",
        icon_class: "el-icon-s-goods",
        name: "供应商信息"
      }
    ]
  }, */
  {
    index: "0",
    total_name: "商品",
    icon_class: "el-icon-s-goods",
    children: [
      /* {
        index: "/MyCard",
        icon_class: "el-icon-bank-card",
        name: "会员卡创建"
      }, */
      {
        index: "/supGoodsInfo",
        icon_class: "el-icon-s-goods",
        name: "商品基本信息"
      },
      {
        index: "/goodsApply",
        icon_class: "el-icon-s-goods",
        name: "商品申请"
      },
      {
        index: "/payment",
        icon_class: "el-icon-s-goods",
        name: "待收款明细"
      }, {
        index: "/returnGoods",
        icon_class: "el-icon-s-goods",
        name: "退货商品报表"
      }, {
        index: "/saleBottom",
        icon_class: "el-icon-s-goods",
        name: "滞销商品列表"
      }, {
        index: "/saleTop",
        icon_class: "el-icon-s-goods",
        name: "热销商品报表"
      }

    ]
  },
  {
    index: "1",
    icon_class: "el-icon-s-custom",
    total_name: "授权",
    children: [
      {
        index: "/musergroup",
        icon_class: "el-icon-user-solid",
        name: "角色管理"
      },
      {
        index: "/peopleinfo",
        icon_class: "el-icon-finished",
        name: "授权操作"
      },
      {
        index: "/shoppermission",
        icon_class: "el-icon-s-shop",
        name: "店铺授权"
      }
    ]
  },
  {
    index: "2",
    total_name: "会员",
    icon_class: "el-icon-vip",
    children: [
      {
        index: "/getCode",
        icon_class: "el-icon-magic-stick",
        name: "领卡二维码"
      },
      {
        index: "/setVipPermission",
        icon_class: "el-icon-s-check",
        name: "会员申请"
      },
      {
        index: "/allvip",
        icon_class: "el-icon-all-vip",
        name: "所有会员"
      },

      {
        index: "/CreateCoupons",
        icon_class: "el-icon-s-ticket",
        name: "快速制卷"
      },
      {
        index: "/couponList",
        icon_class: "el-icon-s-ticket",
        name: "卷列表"
      },
      {
        index: "/CreateActive",
        icon_class: "el-icon-document-add",
        name: "创建活动"
      }
    ]
  },
  {
    index: "3",
    icon_class: "el-icon-s-tools",
    total_name: "设置",
    children: [
      {
        index: "/information",
        icon_class: "el-icon-s-management",
        name: "店铺信息"
      }, {
        index: "/payConfigure",
        icon_class: "el-icon-s-management",
        name: "支付配置"
      }

      /* {
        index: "/tigerzzvideo",
        icon_class: "el-icon-s-finance",
        name: "泰格学习视频"
      } */
      /*,
      {
        //Stashed changes
        index: "/collection",
        icon_class: "el-icon-tickets",
        name: "收费项管理"
      } {
        index: "/wxPayInfo",
        icon_class: "el-icon-s-finance",
        name: "配置微信支付"
      }
 */
      /*  {
      }
    ]
  },
 /*  */
    ]
  },
  {
    index: "5",
    icon_class: "el-icon-s-order",
    total_name: "单据",
    children: [
      {
        index: "/insheet",
        icon_class: "el-icon-sell",
        name: "入库单"
      },
      {
        index: "/outsheet",
        icon_class: "el-icon-sold-out",
        name: "销售单"
      }
    ]
  }
  /* {
    index: "4",
    total_name: "屏幕管理",
    icon_class: "el-icon-s-platform",
    children: [
      {
        index: "/drawtemplate",
        icon_class: "el-icon-video-camera-solid",
        name: "模板设计"
      }
    ]
  }, */
  /*   */ /*{
 index: "6",
 icon_class: "el-icon-s-marketing",
 total_name: "报表查看",
  children: [
   {
     index: "/insheet",
     icon_class: "el-icon-sell",
     name: "入库单"
   },
   {
     index: "/outsheet",
     icon_class: "el-icon-sold-out",
     name: "出库单"
   }
 ]
}*/
  /* {
    index: "6",
    total_name: "支付配置",
    icon_class: "el-icon-s-finance",
    children: [
      {
        index: "/swiftConfigure",
        icon_class: "el-icon-document",
        name: "配置威富通信息"
      }
    ]
  }  */
]
